import { Model, idProp, prop } from '@weavix/mobx';

export class UserSettings extends Model({
    id: idProp,
    settings: prop<any>(),
}) {}
